import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';
import styled from 'styled-components';

import { Banner } from '@/src/components/Banner/Banner';
import { hasBanner } from '@/src/components/Banner/helpers';
import { BenefitsFooter } from '@/src/components/Footer/BenefitsFooter';
import { BenefitsHeader } from '@/src/components/Header';
import { transformProperties } from '@/src/domains/prismic/helpers';

// Rebrand scope (MAWEB-1095): benefit guides are an old-brand template, so remap the legacy
// brand tokens here instead of on :root, which would restyle every other panda page.
// `display: contents` keeps the wrapper out of layout (fixed header, print sizing).
// Fonts: Rotina ships 300/400/700 only, so never declare 500/600 inside this scope.
const RebrandScope = styled.div`
  display: contents;

  --newBrandColor: #14191e;
  --primaryColor: #14191e;
  --brandPrimary: #14191e;
  --colors-irisBlue: #14191e;
  --colors-darkBlue: #14191e;
  --typography-fontBrand: 'Rotina', system-ui, sans-serif;
`;

export const BenefitsLayout = ({ sharedServices, children, ...document }) => {
  const heroIntersection = useHeroIntersection();
  const { bannerSitewide } = sharedServices ?? {};
  const bannerProps = transformProperties(bannerSitewide);
  const { description } = bannerProps ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      <RebrandScope>
        {hasBanner(description) ? <Banner {...bannerProps} /> : null}
        <BenefitsHeader document={document} />
        {children}
        <BenefitsFooter />
      </RebrandScope>
    </HeroContext.Provider>
  );
};
